import React from 'react';
import ReactDOM from 'react-dom';
import './style.scss';
import Navigation from './Navigation';
import { BrowserRouter } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/analytics'

const firebaseConfig = {
    apiKey: "AIzaSyCYfIN8qdHSfEg3ixeLmtFw-mrLeG429UY",
    authDomain: "mgs-tabula.firebaseapp.com",
    projectId: "mgs-tabula",
    storageBucket: "mgs-tabula.appspot.com",
    messagingSenderId: "775243255033",
    appId: "1:775243255033:web:c9b52179d4c0ffe400e628",
    measurementId: "G-4JN3JDERBD"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Navigation />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
